import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { colors, fontSizes } from '@/styles/types';

// Why? Because tailwind-merge doesn't support custom class groups by default so we have to define them
// Example issue: "text-body-l text-neutral-N90" becomes "text-body-l"
// TODO add support for existing text classes like text-[0.5rem] because it does causes the same issue
const customTwMerge = extendTailwindMerge({
  classGroups: {
    'text-color': [{ text: colors }],
    'bg-color': [{ bg: colors }],
    'font-size': [{ text: fontSizes }],
    'border-color': [{ border: colors }],
    'shadow-color': [{ shadow: colors }],
    shadow: [{ shadow: ['card', 'popup', 'tiny', 'border-px'] }],
    'text-wrap': [{ text: ['nowrap', 'truncate', 'wrap'] }],
  },
});

/** Merge classes with tailwind-merge with clsx full feature */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
